import React from "react"
import { Box, Typography } from "@mui/material"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { PANEL_CARD_SX, CARD_TITLE_SX } from "@/theme/panelStyles"

const CHIP_SX = {
  px: 1.1,
  py: 0.35,
  borderRadius: "12px",
  bgcolor: "#eef3f7",
  fontSize: "10.5px",
  color: "#004f7d",
  whiteSpace: "nowrap",
}

// Compact summary of the effective voyage specifications on the Plan step;
// clicking it jumps to the Options step.
function SpecPreviewCard({ plannerVesselSettings, currentDraft, onEdit }) {
  const draft = Number.parseFloat(currentDraft)
  const chips = [
    Number.isFinite(draft) ? `Draft ${draft} m` : null,
    plannerVesselSettings?.loadstate || null,
    plannerVesselSettings?.windLimit != null
      ? `Wind ≤ ${plannerVesselSettings.windLimit} kn`
      : null,
    plannerVesselSettings?.waveLimit != null
      ? `Wave ≤ ${plannerVesselSettings.waveLimit} m`
      : null,
    plannerVesselSettings?.currentLimit != null
      ? `Current ≤ ${plannerVesselSettings.currentLimit} kn`
      : null,
  ].filter(Boolean)

  return (
    <Box sx={{ ...PANEL_CARD_SX, mb: 1.25 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 1 }}>
        <Typography sx={CARD_TITLE_SX}>Voyage Specifications</Typography>
        <Box
          onClick={onEdit}
          sx={{
            ml: "auto",
            display: "flex",
            alignItems: "center",
            fontSize: "11px",
            fontWeight: 600,
            color: "#004f7d",
            cursor: "pointer",
            px: 0.75,
            py: 0.25,
            borderRadius: "8px",
            "&:hover": { bgcolor: "rgba(0,79,125,0.08)" },
          }}
        >
          edit
          <KeyboardArrowRightIcon sx={{ fontSize: 14 }} />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 0.6,
          overflowX: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {chips.map((label) => (
          <Box key={label} sx={CHIP_SX}>
            {label}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default React.memo(SpecPreviewCard)
